import React, {useState} from "react";
import {
    FaFacebookF,
    FaXTwitter,
    FaInstagram,
    FaYoutube,
} from "react-icons/fa6";
import "bootstrap/dist/css/bootstrap.min.css";
import {useTranslation} from "react-i18next";
import {useConfigurator} from "../context/ConfiguratorContext";
import {subscribe} from "../services/CommonService";
import {toast} from "react-toastify";
import Utils from "../utils";

const Footer = () => {
    const {t} = useTranslation();
    const {mainCompanyData} = useConfigurator();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        email: "",
    });

    const validate = () => {
        let newErrors = {};

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/.test(email.trim())) {
            newErrors.email = "Invalid email format";
        }

        return newErrors;
    };

    const handleSubscribe = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setLoading(true);

        const data = {email: email.trim()};

        subscribe(data)
            .then((res) => {
                setEmail("");
                setErrors({});
                toast.success(res.data.message);
            })
            .catch((err) => {
                const msg = Utils.getErrorMessage(err);
                setErrors({email: msg});
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <footer className="footer text-white pt-5 pb-3">
            <div className="container">
                <div className="row">

                    <div className="col-md-4 mb-4">
                        <h5 className="fw-bold">{mainCompanyData?.name}</h5>
                        <p>
                            Solis is one of the fastest-growing tractor brands in the world, trusted by farmers and
                            property owners in over 150 countries. Built for performance, reliability, and value, Solis
                            delivers powerful compact and utility tractors designed to tackle any job with ease. Backed
                            by International Tractors Limited, Solis is committed to helping you work smarter and get
                            more done for less.

                        </p>
                    </div>

                    <div className="col-md-4 mb-4">
                        <h5 className="fw-bold">{t(`subscribe`)}</h5>

                        <form onSubmit={handleSubscribe}>
                            <div className="d-flex flex-column">
                                <div className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control me-2"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />

                                    {loading ? (
                                        <button
                                            type="button"
                                            className="btn btn-orange">
                                            {" "}
                                            Loading...
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="btn btn-orange"
                                        >
                                            {t("subscribe")}
                                        </button>
                                    )}

                                </div>

                                {/* Inline error message */}
                                {errors.email && (
                                    <small className="text-danger mt-1">
                                        {errors.email}
                                    </small>
                                )}
                            </div>
                        </form>
                    </div>

                    {/* Social Links */}
                    <div className="col-md-4 mb-4">
                        <h5 className="fw-bold d-flex justify-content-end">Follow us</h5>
                        <div className="d-flex justify-content-end gap-3 mt-2">
                            <a href="https://www.facebook.com/SolisTractorsUSA" className="text-light me-3"
                               target="_blank" rel="noopener noreferrer">
                                <FaFacebookF/>
                            </a>
                            <a href="https://x.com/UsaTractors" className="text-light me-3" target="_blank"
                               rel="noopener noreferrer">
                                <FaXTwitter/>
                            </a>
                            <a href="https://www.instagram.com/solis_tractors_usa" className="text-light me-3"
                               target="_blank" rel="noopener noreferrer">
                                <FaInstagram/>
                            </a>
                            <a href="https://www.youtube.com/@solistractorsusa9227" className="text-light me-3"
                               target="_blank" rel="noopener noreferrer">
                                <FaYoutube/>
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <div className="text-center mt-3 pt-3 border-top border-secondary w-100">
                © {new Date().getFullYear()} {mainCompanyData?.name}. {t("footerText")}
            </div>
        </footer>
    );
};

export default Footer;
